import { render, staticRenderFns } from "./ProductSelectorSuggested.vue?vue&type=template&id=23fb359e&"
import script from "./ProductSelectorSuggested.vue?vue&type=script&lang=js&"
export * from "./ProductSelectorSuggested.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports